"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActionHandler = exports.doAction = exports.setGeneratorActionHandler = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var handlers = {};

var reject = function reject(action) {
  throw Error({
    reason: "There is no handler for ".concat(action.type),
    action: action
  });
};

var setGeneratorActionHandler = function setGeneratorActionHandler(type, handler) {
  handlers[type] = handler;
};

exports.setGeneratorActionHandler = setGeneratorActionHandler;

var doAction = /*#__PURE__*/_regenerator["default"].mark(function doAction(action) {
  var handler;
  return _regenerator["default"].wrap(function doAction$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          handler = handlers[action.type] || reject;
          return _context.delegateYield(handler(action), "t0", 2);

        case 2:
          return _context.abrupt("return", _context.t0);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, doAction);
});

exports.doAction = doAction;

var setActionHandler = function setActionHandler(type, handler) {
  setGeneratorActionHandler(type, /*#__PURE__*/_regenerator["default"].mark(function _callee(action) {
    return _regenerator["default"].wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.call)(handler, action);

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
};

exports.setActionHandler = setActionHandler;